'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { omit, pick } from 'rich-text-lib/utils/iterables';
import CanvasToolbarButton from 'rich-text-lib/components/toolbar/ToolbarButton';
import { nodeChangeHandlers } from 'tinymce-plugins/utils/formatting';
import { shouldApplyOverrideFormat } from 'tinymce-plugins/hsformatting/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ControlButton extends Component {
  constructor(props) {
    super(props);
    this.getIsActive = () => this.state.isActive || this.props.isActive;
    this.getIsDisabled = () => this.state.isDisabled || this.props.disabled;
    this.onClick = () => {
      const disabled = this.getIsDisabled();
      if (!disabled) {
        this.props.onClick(!this.getIsActive());
      }
    };
    this.state = {
      isActive: false,
      isDisabled: false
    };
    this.handleFormatChanged = this.handleFormatChanged.bind(this);
    this.handleNodeChange = this.handleNodeChange.bind(this);
  }
  componentDidMount() {
    const {
      editor,
      formatName,
      getInitialActive,
      nodesAffectedByInheritedStyles,
      shortCut
    } = this.props;
    const initialActive = getInitialActive();
    if (this.state.isActive !== initialActive) {
      this.setState({
        isActive: initialActive
      });
    }
    if (shortCut) {
      editor.shortcuts.add(shortCut, '', this.onClick);
    }
    if (nodesAffectedByInheritedStyles.length <= 0) {
      editor.on(`FormatChanged:${formatName}`, this.handleFormatChanged);
    }
  }
  componentWillUnmount() {
    const {
      editor,
      formatName,
      shortCut
    } = this.props;
    editor.off(`FormatChanged:${formatName}`, this.handleFormatChanged);
    if (shortCut) {
      editor.shortcuts.remove(shortCut);
    }
  }
  handleNodeChange(evt) {
    const isActive = shouldApplyOverrideFormat(this.props.editor, this.props.nodesAffectedByInheritedStyles) ? nodeChangeHandlers[this.props.formatName](evt) : this.props.editor.formatter.match(this.props.formatName);
    if (isActive !== this.state.isActive) {
      this.setState({
        isActive
      });
    }
  }
  handleFormatChanged(evt) {
    const eventState = pick(['isActive', 'isDisabled'], evt);
    this.setState(Object.assign({}, eventState));
  }
  render() {
    const buttonProps = omit([...Object.keys(ControlButton.propTypes), 'onClick', 'disabled'], this.props);
    return /*#__PURE__*/_jsx(CanvasToolbarButton, Object.assign({
      selected: this.getIsActive(),
      disabled: this.getIsDisabled(),
      onClick: this.onClick,
      name: this.props.formatName
    }, buttonProps));
  }
}
ControlButton.propTypes = {
  editor: PropTypes.object.isRequired,
  formatName: PropTypes.string.isRequired,
  getInitialActive: PropTypes.func,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  nodesAffectedByInheritedStyles: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  shortCut: PropTypes.string
};
ControlButton.defaultProps = {
  getInitialActive: () => false,
  nodesAffectedByInheritedStyles: []
};